/*
 * Searchanise on-demand loader (collection template only). Pairs with
 * snippets/searchanise-gate.liquid; releases the vendor script and swaps out the
 * SSR grid only once Searchanise has painted. Four rules, each learned the hard way:
 * 1 never assume a container id   2 hide the SSR grid on success only
 * 3 disarm the gate before boot   4 a native sort is not a filter
 */
(function () {
  var gate = window.SearchaniseGate;
  if (!gate) return; // not a gated page

  var ssr = document.getElementById('ProductGridContainer');
  var status = document.getElementById('searchanise-status');

  // Facet state only. Deliberately excludes sort_by (rule 4) and Shopify's native
  // filter.* params, which cannot occur while enable_filtering is false.
  var DEEPLINK = /[?&](rb_|snize)/;

  // Any one of these means Searchanise has put products on the page. Matched
  // against the whole document, never scoped to an assumed container.
  var PAINTED = [
    '.snize-product',
    '.snize-item',
    '.snize-search-results-content',
    '#snize_results .snize-results-list'
  ].join(', ');

  function painted() {
    return document.querySelector(PAINTED) !== null;
  }

  function connect() {
    if (connect.done) return;
    connect.done = true;
    ['https://searchanise-ef84.kxcdn.com', 'https://searchserverapi1.com'].forEach(function (origin) {
      var link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = origin;
      link.crossOrigin = '';
      document.head.appendChild(link);
    });
  }

  // Terminal state. Runs exactly once.
  function settle(state) {
    if (settle.done) return;
    settle.done = true;
    document.documentElement.setAttribute('data-snz', state);
    if (status) status.textContent = state === 'ready' ? '' : 'Filters are unavailable right now.';
    if (ssr) ssr.hidden = state === 'ready'; // rule 2 — hide on success only
        if (state === 'ready') {
      requestAnimationFrame(function () { window.dispatchEvent(new Event('resize')); });
      setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 300);
    }
  }

  function watch() {
    if (settle.done) return;

    var giveUp = setTimeout(function () {
      settle('failed');
    }, 10000);

    var mo = new MutationObserver(function () {
      if (!painted()) return;
      clearTimeout(giveUp);
      mo.disconnect();
      settle('ready');
    });
    mo.observe(document.body, { childList: true, subtree: true });

    // Covers the case where Searchanise painted between boot and observer attach.
    if (painted()) {
      clearTimeout(giveUp);
      mo.disconnect();
      settle('ready');
    }
  }

  function boot(reason) {
    if (gate.booted) return;
    gate.booted = true;

    connect();
    document.documentElement.setAttribute('data-snz', 'booting');
    if (status) status.textContent = 'Loading filters…';

    var url = gate.held[0] || gate.fallback;

    // Rule 3. Must happen before the script is appended, not after.
    gate.disarm();

    var s = gate.rawCreate('script');
    s.async = true;
    s.setAttribute('data-snz-boot', reason || 'manual');
    s.onerror = function () {
      // The gate is already disarmed, so asyncLoad will still get its own copy in
      // at window load. Worst case we degrade to the store's current behaviour.
      settle('failed');
    };
    s.src = url;
    document.head.appendChild(s);

    watch();
  }

  // 1. Already carrying facet state — a deep link, or back-navigation from a PDP
  //    into a filtered collection. Boot at once; there is nothing to defer.
  if (DEEPLINK.test(location.search)) {
    boot('deeplink');
    return;
  }

  // 2. Intent. Warm the connection as the shopper reaches for the control, so the
  //    click itself lands on an open socket.
  var trigger = document.querySelector('[data-snz-open]');
  if (trigger) {
    ['pointerenter', 'touchstart', 'focus'].forEach(function (evt) {
      trigger.addEventListener(evt, connect, { once: true, passive: true });
    });
    trigger.addEventListener('click', function () {
      boot('click');
    });
  }

  // 3. Deep scroll warms the connection and must NOT boot. It did once: the grid
  //    swapped under shoppers mid-scroll, and every non-filtering session paid the
  //    full app cost. Painting is reserved for the Filter button and deep links.
  if ('requestIdleCallback' in window) {
    requestIdleCallback(
      function () {
        addEventListener(
          'scroll',
          function onScroll() {
            if (window.scrollY < window.innerHeight * 2) return;
            removeEventListener('scroll', onScroll);
            connect();
          },
          { passive: true }
        );
      },
      { timeout: 4000 }
    );
  }

  gate.boot = boot;
})();
